// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"ec02e575","164":"95a55ca9","245":"b1feb539","246":"a4508a4f","255":"a32925b0","311":"eb274b19","452":"d0c3fa2a","469":"2ecd4ab5","531":"6f6f8228","791":"edb0ea2c","844":"87e81de7","960":"9f0a48b5"}[chunkId] + ".chunk.js";
};